module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--it@2-11aa99a3b9bf841c78579c7f51e55d85.jpg";